import React, { FC, useState } from 'react';

import ProfileGrid from 'components/Profile/ProfileGrid';
import useTheme from 'helpers/useTheme';
import usePageType from 'helpers/usePageType';

import { CardTypeOptions, PrivacyOptions } from 'constants/graphqlTypes';
import { useGetProfileLists, useGetUserCards } from 'graphQL/cards/userCards/hooks';

import { StyledContent, StyledNoListsText, StyledWrap } from './styled';

const { Public, Private } = PrivacyOptions;
const { Card } = CardTypeOptions;

interface IProfileContentProps {
  gradientStartColor?: string | null;
  isListCard?: boolean;
}

const ProfileContent: FC<IProfileContentProps> = ({ gradientStartColor, isListCard }) => {
  const { totalCount } = useGetUserCards({ type: Card, limit: 0 });
  const [showPublicLists, setShowPublicLists] = useState(true);
  const { totalCount: totalLists } = useGetProfileLists({ limit: 0, withPrivacy: true });
  const { lists, loadMore, loading, isQueryCalled } = useGetProfileLists({
    limit: 10,
    privacy: showPublicLists ? Public : Private,
  });
  const { isMyProfile } = usePageType();

  const isDark = useTheme();
  const hasPicks = isMyProfile ? totalCount > 3 : !!totalCount;
  const firstListsLoading = loading && !isQueryCalled;
  const showContent = (hasPicks || !!totalLists) && !firstListsLoading;

  return (
    <>
      {showContent && (
        <StyledWrap isDark={isDark}>
          {!totalLists && (
            <StyledNoListsText isDark={isDark}>
              {isMyProfile ? 'You don’t have any lists yet.' : 'There are no lists yet. '}
            </StyledNoListsText>
          )}
          {!!lists.length && (
            <StyledContent>
              {/* Buttons render inside ProfileGrid so they align with the list layout */}
              <ProfileGrid
                isDark={isDark}
                items={lists}
                loadMore={loadMore}
                loading={loading}
                gradientStartColor={gradientStartColor}
                picksTotalCount={totalCount}
                showPublicLists={showPublicLists}
                setShowPublicLists={setShowPublicLists}
                isListCard={isListCard}
              />
            </StyledContent>
          )}
        </StyledWrap>
      )}
    </>
  );
};

export default ProfileContent;
